const TOKEN_LABEL = 'token';
const CLIENT_REP_CODE_PREFIX = 'clientrepCode';

export default {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  clear() {
    localStorage.removeItem(TOKEN_LABEL);
    this.clearRepCode();

    return true;
  },
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getToken() {
    const token = localStorage.getItem(TOKEN_LABEL);

    if (token) {
      return JSON.parse(token);
    }

    return null;
  },
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setToken(payload) {
    localStorage.setItem(TOKEN_LABEL, JSON.stringify(payload));
  },
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  clearRepCode() {
    const arrlocalStorageKeys = Object.keys(localStorage);

    arrlocalStorageKeys.forEach((item) => {
      if (item.includes(CLIENT_REP_CODE_PREFIX) === true) {
        localStorage.removeItem(item);
      }
    });
  },
};
